import { PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PaymentCardSchema, RegisterPaymentSchemaType } from './schema/PaymentCardSchema';
export const PaymentFormProvider = ({
  children
}: PropsWithChildren) => {
  const methods = useForm<RegisterPaymentSchemaType>({
    resolver: zodResolver(PaymentCardSchema),
    defaultValues: {
      isBusiness: false,
      birthDate: '',
      expireDate: '',
      name: '',
      cardNumber: '',
      businessNumber: '0000000000' // 초기 required 에러를 막기 넣어줌
    },
    mode: 'onBlur'
  });
  return <FormProvider {...methods} data-sentry-element="FormProvider" data-sentry-component="PaymentFormProvider" data-sentry-source-file="PaymentFormProvider.tsx">{children}</FormProvider>;
};